<template lang="pug">
  .content-wrap.jobs-response
    .section
      .container
        .cvs-container
          .cv-wrap(
            v-for="(item, index) in cvs.items"
            :key="item.index"
            :class="{'is-read': item.is_read}"
            @click="markAsActive(item.cv.id)"
          )
            router-link.cv(:to="{name: 'jobseekerCV', params: {lang: getLanguage, id: item.cv.id, previous: $route}}")
              .count {{getListNumber(index)}}.
              .img(:style="{'background-image': item.cv.image_urls ? `url(${item.cv.image_urls.min})` : ''}")
              .name {{item.cv.first_name}} {{ item.cv.last_name }}
        vue-paginate(
        v-if="cvs.total_items"
        :page-count="cvs.total_pages"
        :page-range="10"
        :initial-page="currentPage-1"
        :clickHandler="toPage"
        )
</template>

<script>
import VuePaginate from '@/components/paginate'
import {mapGetters, mapActions} from 'vuex'
import { gettext } from '@/services/TranslateHandler'

export default {
  name: 'jobResponses',
  components: {
    VuePaginate
  },
  data () {
    return {
      cvs: {},
      currentPage: parseInt(this.$route.query.page) || 1,
      jobOfferId: parseInt(this.$route.params.id)
    }
  },
  methods: {
    gettext: gettext,
    ...mapActions([
      'receiveCvsForJobOffers',
      'markAsActiveCvForJobOffer'
    ]),
    markAsActive (id) {
      this.markAsActiveCvForJobOffer({cvId: id, jobOfferId: this.jobOfferId})
    },
    toPage (page) {
      this.currentPage = +page
      this.getCvs()
    },
    getCvs () {
      this.receiveCvsForJobOffers({
        lang: this.getLanguage,
        jobOfferId: this.jobOfferId,
        pageNum: this.currentPage,
        pageSize: this.$store.state.pageSize
      }).then(res => {
        this.cvs = res
      })
    },
    getListNumber (index) {
      return (this.currentPage - 1) * this.$store.state.pageSize + index + 1
    }
  },
  computed: {
    ...mapGetters(['getLanguage'])
  },
  created () {
    this.getCvs()
  }
}
</script>

<style lang='scss' src='./styles.scss'></style>



// WEBPACK FOOTER //
// src/pages/profile/jobs/response/index.vue